import Banner from '@/assets/images/pricingWarn.png';
import { Button } from '@common/components/Button';
import * as AlertDialog from '@radix-ui/react-alert-dialog';
import { useState } from 'react';
import styles from './warnDialog.module.scss';

export const WarnDialog = ({
    title, 
    description, 
    onClose, 
    onConfirm,
    isOpen = false,
    cancelText = "Cancel",
    confirmText = "Update Payment Info"
}: {
    title: string;
    description: string;
    onClose: () => void;
    onConfirm: () => void;
    isOpen?: boolean;
    cancelText?: string;
    confirmText?: string;
}) => {
    return (
        <AlertDialog.Root open={isOpen} onOpenChange={onClose}>
            <AlertDialog.Portal>
                <AlertDialog.Overlay className={styles.alertDialogOverlay} />
                <AlertDialog.Content className={styles.alertDialogContent}>
                    <div className={styles.iconContainer}>
                        <div className={styles.icon}>
                            {/* Credit card with subscription illustration */}
                            <img src={Banner} alt="Banner" />
                        </div>
                    </div>
                    
                    <AlertDialog.Title className={styles.alertDialogTitle}>
                        {title}
                    </AlertDialog.Title>
                    
                    <AlertDialog.Description className={styles.alertDialogDescription}>
                        {description}
                    </AlertDialog.Description>
                    
                    <div className={styles.alertDialogActions}>
                        <AlertDialog.Cancel asChild>
                            <Button 
                                variant="outline" 
                                color="gray" 
                                size="3"
                                onClick={onClose}
                            >
                                {cancelText}
                            </Button>
                        </AlertDialog.Cancel>
                        
                        <AlertDialog.Action asChild>
                            <Button 
                                variant="solid" 
                                color="primary" 
                                size="3"
                                onClick={onConfirm}
                            >
                                {confirmText}
                            </Button>
                        </AlertDialog.Action>
                    </div>
                </AlertDialog.Content>
            </AlertDialog.Portal>
        </AlertDialog.Root>
    );
};

export const usePricingWarnDialog = (openPricingModal: () => void) => {
    const [isExpiredDialogOpen, setIsExpiredDialogOpen] = useState(false);
    const [isCancelDialogOpen, setIsCancelDialogOpen] = useState(false);

    return {
        dialog: <>
            <WarnDialog
                isOpen={isExpiredDialogOpen}
                onClose={() => setIsExpiredDialogOpen(false)}
                onConfirm={() => {setIsExpiredDialogOpen(false); openPricingModal()}}
                title="Your subscription has expired"
                description="Update your payment details to get back on track"
            />
            <WarnDialog
                isOpen={isCancelDialogOpen}
                onClose={() => setIsCancelDialogOpen(false)}
                onConfirm={() => {setIsCancelDialogOpen(false); openPricingModal()}}
                title="Your subscription has been canceled"
                description="Update your payment details to get back on track"
            />
        </>
        ,
        openExpiredDialog: () => setIsExpiredDialogOpen(true),
        openCancelDialog: () => setIsCancelDialogOpen(true),
    };
};